export default __webpack_public_path__ + "static/media/icon-lizard.0f83914c.svg";